module.exports = __webpack_public_path__ + "assets/images/scene-1_c484c2612b0698f492364f3d3e77a7d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-three/croma-abeldo-dialogs/scene-1.png
// module id = 244
// module chunks = 0